import Model from '../../ModelBinding/Model';
import MissionDocumentCollection from './MissionDocumentCollection';
import Member from '../Member/Member';

export default class MissionDocument extends Model {

  public url?: string;
  public filename?:string;
  public original_filename?:string;
  public created_by?: Member;

  bind() {
    this.url = this.getStringAttribute('url');
    this.filename = this.getStringAttribute('filename');
    this.original_filename = this.getStringAttribute('original_filename');
    this.created_by = this.getRelationAttribute('created_by', Member) as Member;
  }

  static getCollection() {
    return MissionDocumentCollection;
  }
}
